import axios from 'axios'

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api'

// Separate axios instance for session validation to avoid circular dependencies
const validationApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const sessionToken = localStorage.getItem('sessionToken')
      
      // If we have a sessionToken, validate it
      if (sessionToken) {
        try {
          const validateResponse = await validationApi.post('/api/auth/validate-session', { sessionToken })
          if (!validateResponse.data.valid) {
            // Session expired, clear everything and redirect
            localStorage.removeItem('token')
            localStorage.removeItem('sessionToken')
            window.location.href = '/signin'
          }
        } catch (validateError) {
          // Session validation failed, clear everything and redirect
          localStorage.removeItem('token')
          localStorage.removeItem('sessionToken')
          window.location.href = '/signin'
        }
      } else {
        // No sessionToken, just clear token and redirect
        localStorage.removeItem('token')
        window.location.href = '/signin'
      }
    }
    return Promise.reject(error)
  }
)

export const authAPI = {
  signUp: (userData) => {
    console.log('AuthAPI: Sign up request with data:', userData)
    return api.post('/api/auth/register', userData)
  },
  signIn: (credentials) => {
    console.log('AuthAPI: Sign in request with credentials:', credentials)
    console.log('AuthAPI: Making POST request to:', api.defaults.baseURL + '/api/auth/login')
    return api.post('/api/auth/login', credentials)
  },
  signOut: (sessionToken) => api.post('/api/auth/logout', { sessionToken }),
  validateSession: (sessionToken) => api.post('/api/auth/validate-session', { sessionToken }),
  getProfile: () => api.get('/api/auth/profile'),
  updateProfile: (payload) => api.patch('/api/auth/profile', payload),
  updateProfilePicture: (profile_picture) => api.patch('/api/auth/profile/picture', { profile_picture }),
  refreshToken: () => api.post('/api/auth/refresh'),
}